var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var Vue3TooltipRenderer = /** @class */ (function () {
    function Vue3TooltipRenderer(Vue3, param) {
        this._Vue3 = Vue3;
        this._param = param;
    }
    Vue3TooltipRenderer.prototype.init = function (dom, option) {
        var _this = this;
        var _a = this._Vue3, createApp = _a.createApp, defineComponent = _a.defineComponent, shallowRef = _a.shallowRef;
        var self = this;
        var component = defineComponent(__assign(__assign({ setup: function () {
                var paramRef = shallowRef({
                    points: [],
                    title: '',
                    mouse: {},
                });
                self.updateParam = function (param) {
                    paramRef.value = param;
                };
                return function () { return option.formatter(paramRef.value); };
            } }, this._param), { updated: function () {
                if (_this.updateCallback) {
                    _this.updateCallback();
                }
            } }));
        var app = createApp(component);
        app.mount(dom);
        this._tooltip = app;
    };
    Vue3TooltipRenderer.prototype.update = function (dom, formatContent, tooltipParam) {
        if (!this._tooltip) {
            return;
        }
        this.updateParam(tooltipParam);
    };
    Vue3TooltipRenderer.prototype.updateParam = function (tooltipParam) {
        tooltipParam; // do nothing
    };
    Vue3TooltipRenderer.prototype.destroy = function () {
        this._tooltip.unmount();
    };
    return Vue3TooltipRenderer;
}());
export default Vue3TooltipRenderer;
